import { Role } from "../constants/Role";
import { useUserRolesIncludes } from "./useUserRolesIncludes";

/**
 * Check if the current user is a Kannegiesser / ETECH employee.
 */
export const useUserCurrentIsKannegiesserEmployee = () => {
  return useUserRolesIncludes([Role.ADMIN, Role.DEVELOPER, Role.OPERATIONS, Role.PROGRAMMER, Role.TECHNICIAN]);
};
